export enum ModalReportEnumType {
  suggestion,
  bug
}

export type ModalReportData = { type: ModalReportEnumType };
